// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__-hXYc","list":"MainNavigation_list__odzxd","active":"MainNavigation_active__wFQY3"};